// Custom Wishlist functionality using localStorage

// Initialize wishlist on page load
document.addEventListener('DOMContentLoaded', function() {
  initializeWishlist();
});

function initializeWishlist() {
  // Check all wishlist buttons and update their state based on localStorage
  const wishlistButtons = document.querySelectorAll('.wishlist-btn');
  const wishlist = getWishlistFromStorage();
  
  wishlistButtons.forEach(button => {
    const productId = button.dataset.productId;
    if (wishlist.some(item => item.id === productId)) {
      updateHeartState(button, true);
    }
  });
}

function toggleWishlist(button) {
  const productData = {
    id: button.dataset.productId,
    handle: button.dataset.productHandle,
    title: button.dataset.productTitle,
    url: button.dataset.productUrl,
    image: button.dataset.productImage,
    price: button.dataset.productPrice,
    comparePrice: button.dataset.productComparePrice,
    available: button.dataset.productAvailable === 'true'
  };
  
  let wishlist = getWishlistFromStorage();
  const existingIndex = wishlist.findIndex(item => item.id === productData.id);
  
  if (existingIndex > -1) {
    // Remove from wishlist
    wishlist.splice(existingIndex, 1);
    updateHeartState(button, false);
    showNotification(`${productData.title} removed from wishlist`, 'removed');
  } else {
    // Add to wishlist
    wishlist.push(productData);
    updateHeartState(button, true);
    showNotification(`${productData.title} added to wishlist`, 'added');
  }
  
  saveWishlistToStorage(wishlist);
  updateWishlistCount();
  
  // Update wishlist display if the function exists (on wishlist page)
  if (typeof displayWishlistItems === 'function') {
    displayWishlistItems();
  }
}

function updateHeartState(button, isInWishlist) {
  const heart = button.querySelector('.wishlist-heart');
  
  if (isInWishlist) {
    // Heart filled state
    heart.classList.remove('stroke-gray-400', 'fill-transparent');
    heart.classList.add('stroke-red-500', 'fill-red-500');
    button.classList.add('wishlist-active');
  } else {
    // Heart empty state
    heart.classList.remove('stroke-red-500', 'fill-red-500');
    heart.classList.add('stroke-gray-400', 'fill-transparent');
    button.classList.remove('wishlist-active');
  }
}

function getWishlistFromStorage() {
  try {
    const wishlist = localStorage.getItem('customWishlist');
    return wishlist ? JSON.parse(wishlist) : [];
  } catch (error) {
    console.error('Error reading wishlist from localStorage:', error);
    return [];
  }
}

function saveWishlistToStorage(wishlist) {
  try {
    localStorage.setItem('customWishlist', JSON.stringify(wishlist));
  } catch (error) {
    console.error('Error saving wishlist to localStorage:', error);
  }
}

function getWishlistCount() {
  return getWishlistFromStorage().length;
}

function updateWishlistCount() {
  const count = getWishlistCount();
  const countElements = document.querySelectorAll('.wishlist-count');
  
  countElements.forEach(element => {
    element.textContent = count;
    element.style.display = count > 0 ? 'inline' : 'none';
  });
}

function clearWishlist() {
  localStorage.removeItem('customWishlist');
  initializeWishlist();
  updateWishlistCount();
  showNotification('Wishlist cleared', 'removed');
  
  // Update wishlist display if the function exists (on wishlist page)
  if (typeof displayWishlistItems === 'function') {
    displayWishlistItems();
  }
}

function showNotification(message, type) {
  // Create notification element
  const notification = document.createElement('div');
  notification.className = `wishlist-notification fixed right-4 top-1/2 transform -translate-y-1/2 translate-x-full z-50 px-6 py-4 rounded-lg shadow-xl transition-all duration-300`;
  
  // Add background container styling
  notification.style.cssText += `
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    min-width: 280px;
    max-width: 320px;
  `;
  
  if (type === 'added') {
    notification.classList.add('bg-green-500', 'text-white');
    notification.style.backgroundColor = "#194368";
  } else {
    notification.classList.add('bg-red-500', 'text-white');
    notification.style.backgroundColor = 'rgba(239, 68, 68, 0.95)';
  }
  
  notification.textContent = message;
  document.body.appendChild(notification);
  
  // Animate in
  setTimeout(() => {
    notification.classList.remove('translate-x-full');
  }, 100);
  
  // Animate out and remove
  setTimeout(() => {
    notification.classList.add('translate-x-full');
    setTimeout(() => {
      if (notification.parentNode) {
        document.body.removeChild(notification);
      }
    }, 300);
  }, 3000);
}

// Export functions for use in other scripts
window.customWishlist = {
  toggle: toggleWishlist,
  get: getWishlistFromStorage,
  clear: clearWishlist,
  count: getWishlistCount,
  updateCount: updateWishlistCount,
  showNotification: showNotification
};

// Export updateHeartState globally for use in wishlist display
window.updateHeartState = updateHeartState;